module.exports = __webpack_public_path__ + "img/icn2.1fbe81ba.svg";